import { isEmpty } from 'lodash';
import requester from 'utils/requester';
import api from 'config/api';
import { IRequesterResponse, DetailsObjectType, EpisodeType } from './loader-types';

type paramsType = { type: DetailsObjectType['type']; id: number };

export const detailsPageLoader = async ({ id, type }: paramsType) => {
  const isSeries = type === 'series';

  const { data: details } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}/${id}`,
    params: {
      $expand: `genres,resources(url),persons,entitlement,bookmark,favorite${
        isSeries ? ',series_seasons' : ''
      }`,
    },
  })) as IRequesterResponse<DetailsObjectType>;

  if (isSeries && !isEmpty(details.series_seasons)) {
    const seasons = await Promise.all(
      details.series_seasons.map(async (season) => {
        const { data: episodes } = (await requester({
          method: 'get',
          url: `${api.host}${api.endpoints.assets}`,
          params: {
            $expand: '*',
            'season.id[in]': season.id,
          },
        })) as IRequesterResponse<EpisodeType[]>;
        return { ...season, episodes };
      }),
    );
    details.series_seasons = seasons.sort((a, b) => a.season_index - b.season_index);
  }

  const { data: recommendations } = (await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.assets}/${id}/similar`,
    params: {
      'categories.ext_id[in]': id,
      'categories.ext_id[neq]': 'tv',
      $expand: 'resources(url),entitlement,favorite,bookmark',
      $orderby: '-year',
      $limit: 20,
      $offset: 0,
    },
  })) as IRequesterResponse<DetailsObjectType[]>;

  return { details, recommendations };
};
